import { Route } from '@angular/router';
import { TaskFolderResolver, TaskResolver } from './aggregated-tasks.resolvers';
import { AggregatedTasksComponent } from './aggregated-tasks.component';
import { AggregatedTaskListComponent } from './aggregated-tasks-list/aggregated-tasks-list.component';
import { AggregatedTaskDetailsComponent } from './aggregated-tasks-details/aggregated-tasks-details.component';
import { CanDeactivateAggregatedTasksDetails } from './aggregated-tasks.guards';
import { ProjectDataResolver, ProjectsFieldDefsResolver } from 'app/modules/projects/projects.resolvers';
import { TaskFieldDefsResolver } from 'app/shared/modules/legacy-tasks/tasks.resolvers';
import { SavedViewResolver, SavedViewsResolver } from 'app/core/resolvers/saved-views.resolver';
import { Module, Permission } from 'app/core/enums';
import { AuthorizationGuard } from 'app/core/guards/authorization.guard';
import { RelatedToType } from '@shared/enums';

export const tasksRoutes: Route[] = [
  {
    path: 'global',
    data: { taskModuleRelatedTo: RelatedToType.Account, module: Module.GLOBAL_TASKS },
    canActivate: [AuthorizationGuard],
    loadChildren: () => import('app/shared/modules/legacy-tasks/tasks.module').then((m) => m.LegacyTasksTabModule),
  },
  {
    path: 'aggregated',
    redirectTo: 'aggregatedtasks',
    pathMatch: 'full',
  },
  {
    path: 'aggregatedtasks',
    component: AggregatedTasksComponent,
    resolve: {
      savedViews: SavedViewsResolver,
    },
    data: { module: Module.AGGREGATED_TASKS, permission: Permission.TASK_LIST_AGGREGATE },
    canActivate: [AuthorizationGuard],
    children: [
      {
        path: ':saved_view_id/table',
        component: AggregatedTaskListComponent,
        resolve: {
          options: ProjectDataResolver,
          taskFieldDefs: TaskFieldDefsResolver,
          fieldDefs: ProjectsFieldDefsResolver,
          savedView: SavedViewResolver,
        },
        children: [
          {
            path: ':task_list_id/:task_id',
            component: AggregatedTaskDetailsComponent,
            resolve: {
              options: ProjectDataResolver,
              savedViews: SavedViewsResolver,
              savedView: SavedViewResolver,
              folder: TaskFolderResolver,
            },
            canDeactivate: [CanDeactivateAggregatedTasksDetails],
          },
        ],
      },
    ],
  },
];
